<template>
  <div
    id="printpage"
    class="pl-1 pr-1"
  >
    <div class="row mb-3">
      <div class="col-12">
        <img
          src="/static/img/bsa/woodbadge-icon-full-color.png"
          style="height: 80px;width:80px;"
        >
        <span
          class="h1 ml-5 align-middle"
          style="font-family: Raleway"
        >Wood Badge Ticket Worksheet</span>
      </div>
    </div>
    <div class="row">
      <div class="col-2 printBorder printLabel faux-center-3">
        Name
      </div>
      <div class="col-4 printBorder printValue">
        {{ supportInfo.ScouterFullName }}
      </div>
      <div class="col-3 printBorder printLabel">
        Wood Badge Course Number
      </div>
      <div class="col-3 printBorder printValue">
        {{ $root.courseName }}
      </div>
    </div>
    <div class="row">
      <div class="col-2 printBorder printLabel">
        Email Address
      </div>
      <div class="col-4 printBorder printValue print-long-word">
        {{ supportInfo.ScouterEmailAddress }}
      </div>
      <div class="col-3 printBorder printLabel">
        Home Phone Number
      </div>
      <div class="col-3 printBorder printValue">
        {{ supportInfo.ScouterPhoneNumber }}
      </div>
    </div>
    <div
      class="row"
      style="height: 110px"
    >
      <div class="col-6 printBorder printLabel faux-center-4">
        Primary Scouting Position
      </div>
      <div class="col-6 printBorder printValue">
        {{ supportInfo.ScouterPrimaryScoutingPosition }}
      </div>
    </div>
    <div class="row">
      <div class="col-12 printBorder printLabel">
        My Personal Vision of Success
      </div>
    </div>
    <div
      class="row"
      style="height: 300px"
    >
      <div class="col-12 printBorder printValue">
        {{ ticket.Vision }}
      </div>
    </div>
    <div class="row">
      <div class="col-6 printBorder printLabel">
        Ticket Counselor Name
      </div>
      <div class="col-6 printBorder printValue">
        {{ supportInfo.CounselorName }}
      </div>
    </div>
    <div class="row">
      <div class="col-6 printBorder printLabel">
        Ticket Counselor Phone Number
      </div>
      <div class="col-6 printBorder printValue">
        {{ supportInfo.CounselorPhoneNumber }}
      </div>
    </div>
    <div class="row">
      <div class="col-6 printBorder printLabel">
        Ticket Counselor Email Address
      </div>
      <div class="col-6 printBorder printValue">
        {{ supportInfo.CounselorEmailAddress }}
      </div>
    </div>
    <div class="row">
      <div class="col-6 printBorder printLabel">
        Course Director Name
      </div>
      <div class="col-6 printBorder printValue">
        {{ supportInfo.CourseDirectorName }}
      </div>
    </div>
    <div class="row">
      <div class="col-6 printBorder printLabel">
        Course Director Phone Number
      </div>
      <div class="col-6 printBorder printValue">
        {{ supportInfo.CourseDirectorPhoneNumber }}
      </div>
    </div>
    <div class="row">
      <div class="col-6 printBorder printLabel">
        Course Director Email Address
      </div>
      <div class="col-6 printBorder printValue">
        {{ supportInfo.CourseDirectorEmailAddress }}
      </div>
    </div>
    <div
      class="row"
      style="height: 90px"
    >
      <div class="col-12" />
    </div>
    <div class="row">
      <div class="col-12 printBorder printLabel">
        You have 18 months to work your ticket. If you have a question or
        concern about any part of your ticket, please contact your Ticket
        Counselor as soon as possile to discuss the issue.
      </div>
    </div>
    <div class="row pageBreakAfter">
      <div class="col-6 printBorder printLabel">
        Your ticket completion deadline is:
      </div>
      <div class="col-6 printBorder printValue">
        {{ ticketDeadline }}
      </div>
    </div>
    <div
      class="pageBreakBefore pageBreakAfter"
      v-for="goal in ticket.TicketGoals"
      :key="goal.Id"
    >
      <div class="row">
        <div class="col-2 printBorder goalAttributeLabel text-center">
          Ticket Goal
        </div>
        <div class="col-10 printBorder goalAttribute">
          Write a short statement that gives a simple description or overview of
          this ticket goal.
        </div>
      </div>
      <div
        class="row"
        style="height: 70px"
      >
        <div class="col-12 printBorder goalValue">
          {{ goal.Overview }}
        </div>
      </div>
      <div class="row">
        <div
          class="col-2 printBorder goalAttributeLabel text-center"
          style="padding-top: 30px"
        >
          <h2>S</h2>
          Specific
        </div>
        <div class="col-10 printBorder goalAttribute">
          What exactly will you accomplish? Goals are clear, detailed, and
          unambiguous. A specific goal will usually answer the five "W"
          questions:
          <ul style="margin-bottom: 0">
            <li>What: What do I want to accomplish?</li>
            <li>
              Why: Specific reasons, purpose, or benefits of accomplishing the
              goal
            </li>
            <li>Who: Who is involved?</li>
            <li>Where: Identify a location.</li>
            <li>Which: Identify requirements and constraints</li>
          </ul>
        </div>
      </div>
      <div
        class="row"
        style="height: 70px"
      >
        <div class="col-12 printBorder goalValue">
          {{ goal.Specific }}
        </div>
      </div>
      <div class="row">
        <div
          class="col-2 printBorder goalAttributeLabel text-center"
          style="padding-top: 30px"
        >
          <h2>M</h2>
          Measurable
        </div>
        <div class="col-10 printBorder goalAttribute">
          This term stresses the need for concrete criteria for measuring
          progress toward the attainment of the goal. If a goal is not
          measurable, it is not possible to know whether progress toward
          successful completion is being made. A measurable goal will usually
          answer questions such as:
          <ul style="margin-bottom: 0">
            <li>How much?</li>
            <li>How many?</li>
            <li>How will I know when itis accomplished?</li>
          </ul>
        </div>
      </div>
      <div
        class="row"
        style="height: 70px"
      >
        <div class="col-12 printBorder goalValue">
          {{ goal.Measurable }}
        </div>
      </div>
      <div class="row">
        <div
          class="col-2 printBorder goalAttributeLabel text-center"
          style="padding-top: 30px"
        >
          <h2>A</h2>
          Attainable
        </div>
        <div class="col-10 printBorder goalAttribute">
          This term stresses the importance of goals that are realistic and
          attainable. While an attainable goal may stretch the goal-setter to
          achieve it, the goal is not extreme. An attainable goal will usually
          answer questions such as:
          <ul style="margin-bottom: 0">
            <li>How can this goal be accomplished?</li>
            <li>
              What kind of roadblocks might interfere, and how can they be
              overcome?
            </li>
          </ul>
        </div>
      </div>
      <div
        class="row"
        style="height: 70px"
      >
        <div class="col-12 printBorder goalValue">
          {{ goal.Attainable }}
        </div>
      </div>
      <div class="row">
        <div
          class="col-2 printBorder goalAttributeLabel text-center"
          style="padding-top: 20px"
        >
          <h2>R</h2>
          Relevant
        </div>
        <div class="col-10 printBorder goalAttribute">
          A relevant goal must represent an objective that the goal-setter is
          willing and able to work toward. A relevant goal will usually answer
          the questions:
          <ul style="margin-bottom: 0">
            <li>Does this seem worthwhile?</li>
            <li>Why is this goal significant to my role in Scouting?</li>
          </ul>
        </div>
      </div>
      <div
        class="row"
        style="height: 70px"
      >
        <div class="col-12 printBorder goalValue">
          {{ goal.Relevant }}
        </div>
      </div>
      <div class="row">
        <div
          class="col-2 printBorder goalAttributeLabel text-center"
          style="padding-top: 30px"
        >
          <h2>T</h2>
          Timely
        </div>
        <div class="col-10 printBorder goalAttribute">
          When will you achieve this goal? A commitment to a deadline helps
          focus efforts on completion of the goal on or before the due date. A
          timely goal will usually answer questions such as "when":
          <ul style="margin-bottom: 0">
            <li>What can I do 5 months from now?</li>
            <li>What can I do 12 months from now?</li>
            <li>What can I do today?</li>
          </ul>
        </div>
      </div>
      <div
        class="row"
        style="height: 70px"
      >
        <div class="col-12 printBorder goalValue">
          {{ goal.Timely }}
        </div>
      </div>
      <div class="row">
        <div class="col-2 printBorder goalAttributeLabel">
          Does This Goal
        </div>
        <div
          style="line-height: 1.1"
          class="col-3 printBorder goalAttributeLabel text-center"
        >
          Promote Diversity?<br>
          <span v-if="goal.PromotesDiversity"><input
            style="margin-right: 2px"
            type="checkbox"
            checked
          >Yes<input
            style="margin-left: 5px; margin-right: 2px"
            type="checkbox"
          >No</span>
          <span v-else><input
            style="margin-right: 2px"
            type="checkbox"
          >Yes<input
            style="margin-left: 5px; margin-right: 2px"
            type="checkbox"
            checked
          >No</span>
        </div>
        <div
          style="line-height: 1.1"
          class="col-4 printBorder goalAttributeLabel text-center"
        >
          Promote Membership Growth and Retention?<br>
          <span v-if="goal.PromotesMembership"><input
            style="margin-right: 2px"
            type="checkbox"
            checked
          >Yes<input
            style="margin-left: 5px; margin-right: 2px"
            type="checkbox"
          >No</span>
          <span v-else><input
            style="margin-right: 2px"
            type="checkbox"
          >Yes<input
            style="margin-left: 5px; margin-right: 2px"
            type="checkbox"
            checked
          >No</span>
        </div>
        <div
          style="line-height: 1.1"
          class="col-3 printBorder goalAttributeLabel text-center"
        >
          Show a Line of Sight to the Youth?<br>
          <span v-if="goal.ShowsLineOfSight"><input
            style="margin-right: 2px"
            type="checkbox"
            checked
          >Yes<input
            style="margin-left: 5px; margin-right: 2px"
            type="checkbox"
          >No</span>
          <span v-else><input
            style="margin-right: 2px"
            type="checkbox"
          >Yes<input
            style="margin-left: 5px; margin-right: 2px"
            type="checkbox"
            checked
          >No</span>
        </div>
      </div>
      <div class="row">
        <div class="col-2 printBorder goalAttributeLabel">
          Ticket Counselor Goal Approval
        </div>
        <div
          class="col-6 printBorder"
          :value="getTicketCounselorSignature(goal)"
        />
        <div
          class="col-4 printBorder goalAttributeLabel"
          :value="getTicketCounselorDate(goal)"
        />
      </div>
    </div>
  </div>
</template>

<script>
import formatter from '@/services/formatter.js'
import scouterApi from '@/services/api/scouter'

export default {
  name: 'TicketPrint',
  props: {
    ticket: {
      type: Object,
      default: function () {
        return {}
      }
    },
    supportInfo: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data: function () {
    return {
      options: [
        { text: 'Yes', key: 'Yes', value: 'Yes' },
        { text: 'No', key: 'No', value: 'No' }
      ],
      staffMappings: {},
      value1: ['Yes'],
      value2: false,
      value3: 'Yes'
    }
  },
  created: function () {
    this.getStaffList()
  },
  computed: {
    ticketDeadline: function () {
      return formatter.formatAsDate(this.supportInfo.TicketDeadline)
    },
    goal0Diversity: function () {
      return this.ticket.TicketGoals[0].PromotesDiversity ? ['Yes'] : ['No']
    },
    goal1Diversity: function () {
      return this.ticket.TicketGoals[1].PromotesDiversity ? 'Yes' : 'No'
    },
    goal2Diversity: function () {
      return this.ticket.TicketGoals[2].PromotesDiversity ? 'Yes' : 'No'
    },
    goal3Diversity: function () {
      return this.ticket.TicketGoals[3].PromotesDiversity ? 'Yes' : 'No'
    },
    goal4Diversity: function () {
      return this.ticket.TicketGoals[4].PromotesDiversity ? 'Yes' : 'No'
    },
    goal0Membership: function () {
      return this.ticket.TicketGoals[0].PromotesMembership ? 'Yes' : 'No'
    },
    goal1Membership: function () {
      return this.ticket.TicketGoals[1].PromotesMembership ? 'Yes' : 'No'
    },
    goal2Membership: function () {
      return this.ticket.TicketGoals[2].PromotesMembership ? 'Yes' : 'No'
    },
    goal3Membership: function () {
      return this.ticket.TicketGoals[3].PromotesMembership ? 'Yes' : 'No'
    },
    goal4Membership: function () {
      return this.ticket.TicketGoals[4].PromotesMembership ? 'Yes' : 'No'
    },
    goal0Youth: function () {
      return this.ticket.TicketGoals[0].ShowsLineOfSight ? 'Yes' : 'No'
    },
    goal1Youth: function () {
      return this.ticket.TicketGoals[1].ShowsLineOfSight ? 'Yes' : 'No'
    },
    goal2Youth: function () {
      return this.ticket.TicketGoals[2].ShowsLineOfSight ? 'Yes' : 'No'
    },
    goal3Youth: function () {
      return this.ticket.TicketGoals[3].ShowsLineOfSight ? 'Yes' : 'No'
    },
    goal4Youth: function () {
      return this.ticket.TicketGoals[4].ShowsLineOfSight ? 'Yes' : 'No'
    }
  },
  methods: {
    getTicketCounselorSignature: function (goal) {
      if (goal.ApprovedByScouterKey) {
        return this.staffMappings[goal.ApprovedByScouterKey]
      } else {
        return ''
      }
    },
    getTicketCounselorDate: function (goal) {
      if (goal.ApprovedByScouterKey) {
        return formatter.formatAsDate(goal.ApprovalDate)
      } else {
        return ''
      }
    },
    getStaffList: function () {
      scouterApi
        .getStaffCourseScouterLookups(this.$root.courseKey)
        .then(y => {
          this.staffMappings = y
        })
        .catch(error => {
          console.log(error)
          this.$notify({
            message: 'There was an error retrieving your data.',
            icon: 'bi bi-exclamation-circle-fill',
            type: 'error',
            horizontalAlign: 'center',
            timeout: 2000
          })
          this.errormessage = error
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.printLabel {
  font-size: 32px;
  font-family: Raleway, Verdana, Geneva, Tahoma, sans-serif;
  line-height: 1.1;
  padding: 15px;
}
.printValue {
  font-size: 30px;
  font-family: "Courier New", Courier, monospace;
  line-height: 1.1;
  padding: 15px;
}
.print-long-word {
  word-break: break-all;
}
.printBorder {
  border: 1px solid black;
}
.faux-center-3 {
  padding-top: 30px;
}
.faux-center-7 {
  padding-top: 70px;
}
.standard-height {
  height: 100px;
}
</style>
